import { translate } from "@classdojo/web/utils/translate";
import PairShareEdit from "./PairShareEdit";
import PairShareResult from "./PairShareResult";
import { appMetadataPairshare } from "src/pods/pairshare";
import EditableToolContainer from "src/pods/toolkitData/components/EditableToolContainer";
import SavedToolButton from "src/pods/toolkitData/components/SavedToolButton";

const QUESTIONS = () => [
  {
    str: translate("dojo.toolkit:think_pair_share.default_questions.gratefulness"),
    dojoId: "pairShareGratefulness",
  },
  {
    str: translate("dojo.toolkit:think_pair_share.default_questions.improvement"),
    dojoId: "pairShareImprovement",
  },
  {
    str: translate("dojo.toolkit:think_pair_share.default_questions.struggle"),
    dojoId: "pairShareStruggle",
  },
];

export type PairShareContainerProps = {
  params: {
    classId: string;
    mountPoint: string;
    app: string;
  };
};

export default function PairShareContainer(props: PairShareContainerProps) {
  return (
    <EditableToolContainer
      toolType="pairShare"
      title={translate("dojo.toolkit:think_pair_share.display_a_question")}
      appMetadata={appMetadataPairshare()}
      {...props}
      suggestedTools={QUESTIONS().map(({ str, dojoId }) => ({
        dojoId,
        payload: {
          text: str,
        },
      }))}
      renderItem={({ tool, openEditScreen, showTool }) => (
        <SavedToolButton
          data-name={`pair_share_container:saved_tool_button:${tool._id || tool.dojoId}`}
          key={tool._id || tool.dojoId}
          onRowClick={() => showTool(tool)}
          onEditClick={tool.dojoId ? null : () => openEditScreen(tool)}
        >
          {tool.payload.text}
        </SavedToolButton>
      )}
      renderEditItem={({ onEdit, payload }) => <PairShareEdit onEdit={onEdit} payload={payload} />}
      renderResult={({ tool }) => <PairShareResult question={tool} />}
      getDisplayPayload={(question) => ({
        type: "RECEIVE_QUESTION",
        payload: { question },
      })}
    />
  );
}
